import tin_tuc from 'content/assets/images/icon-products/tin_tuc.svg';
import bach_khoa_group from 'content/assets/images/icon-products/group_bk.svg';
import lms360 from 'content/assets/images/icon-products/lms360.svg';
import quan_ly_truong_hoc from 'content/assets/images/icon-products/quan_ly_truong_hoc.svg';
import so_lien_lac_dt from 'content/assets/images/icon-products/so_lien_lac_dt.svg';
import danh_gia_nang_luc from 'content/assets/images/icon-products/danh_gia_nang_luc.svg';
import diem_danh_ai from 'content/assets/images/icon-products/diem_danh_ai.svg';
import thoi_khoa_bieu from 'content/assets/images/icon-products/thoi_khoa_bieu.svg';
import hoc_ba_so from 'content/assets/images/icon-products/hoc_ba_so.svg';
import kiem_dinh_cldt from 'content/assets/images/icon-products/kiem_dinh_cldt.svg';
import danh_gia_va_tdg from 'content/assets/images/icon-products/danh_gia_va_tdg.svg';
import hoc_lieu_so_ban_quyen from 'content/assets/images/icon-products/hoc_lieu_so_ban_quyen.svg';
import dao_tao_nhan_luc_so from 'content/assets/images/icon-products/dao_tao_nhan_luc_so.svg';
import hoc_lieu_so_dung_chung from 'content/assets/images/icon-products/hoc_lieu_so_dung_chung.svg';
import pascal from 'content/assets/images/icon-products/pascal.png';
import tinhhoabooks from 'content/assets/images/icon-products/tinhhoabooks.png';
import logo_avs from 'content/assets/images/icon-products/logo_avs.jpeg';
import thi_nghiem_ao from 'content/assets/images/icon-products/thi_nghiem_ao.svg';

export const bktProducts = [
  {
    id: 1,
    img: tin_tuc,
    title: 'Tin tức',
    link: 'https://tintuc.lms360.edu.vn/'
  },
  {
    id: 2,
    img: lms360,
    title: 'LMS360',
    link: 'https://lms360.edu.vn'
  },
  {
    id: 4,
    img: hoc_ba_so,
    title: 'Học bạ số',
    link: 'https://qlth.lms360.edu.vn'
  },
  {
    id: 18,
    img: thi_nghiem_ao,
    title: 'Thí nghiệm ảo',
    link: 'https://lms360.edu.vn/virtual-lab'
  },
  {
    id: 3,
    img: quan_ly_truong_hoc,
    title: 'Quản lý trường học',
    link: 'https://qlth.lms360.edu.vn'
  },
  {
    id: 10,
    img: bach_khoa_group,
    title: 'Bách Khoa Group',
    link: 'https://bachkhoa.tech'
  },
  {
    id: 5,
    img: danh_gia_va_tdg,
    title: (
      <p className="mb-0">
        Thi đua
        <br />
        khen thưởng
      </p>
    ),
    link: 'https://thiduakhenthuong.hcm.edu.vn'
  },

  {
    id: 7,
    img: kiem_dinh_cldt,
    title: 'Kiểm định CLGD',
    link: 'https://kiemdinh.lms360.edu.vn'
  },
  {
    id: 8,
    img: thoi_khoa_bieu,
    title: 'Thời khoá biểu',
    link: 'https://qlth.lms360.edu.vn'
  },
  {
    id: 9,
    img: diem_danh_ai,
    title: 'Điểm danh bằng AI',
    link: 'https://qlth.lms360.edu.vn'
  },
  {
    id: 16,
    img: so_lien_lac_dt,
    title: 'Sổ liên lạc điện tử',
    link: 'https://qlth.lms360.edu.vn'
  },
  {
    id: 17,
    img: hoc_lieu_so_dung_chung,
    title: 'Học liệu số dùng chung',
    link: ''
  },
  {
    id: 6,
    img: danh_gia_va_tdg,
    title: 'Đánh giá và tự đánh giá',
    link: 'https://thidua.vn/'
  },
  {
    id: 11,
    img: dao_tao_nhan_luc_so,
    title: 'Đào tạo nhân sự số',
    link: '/tin-tuc-elearning?contentId=0'
  },
  {
    id: 12,
    img: danh_gia_nang_luc,
    title: 'Đánh giá năng lực',
    link: 'https://khaosat7.hcm.edu.vn/'
  },
  {
    id: 17,
    img: hoc_lieu_so_ban_quyen,
    title: 'Học liệu số bản quyền',
    link: 'https://lms360.edu.vn/danh-sach-khoa-hoc-nxb'
  },
  // {
  //   id: 13,
  //   img: pascal,
  //   title: 'Trường học Pascal',
  //   link: 'https://passchool.edu.vn/'
  // },
  {
    id: 14,
    img: tinhhoabooks,
    title: 'Tinh Hoa Books',
    link: 'https://tinhhoabooks.com/'
  },
  {
    id: 15,
    img: logo_avs,
    title: 'AVS Education',
    link: 'https://anhngu.avsgroup.edu.vn/'
  }
];

export const AiLinks = [
  {
    iconUrl: '/ai-attendance.png',
    text: 'Điểm danh thông minh, nhận diện gương mặt bằng AI',
    videoUrl: 'https://lms360.edu.vn/video/attendance-by-cammera.mp4',
    type: 'video'
  },
  {
    iconUrl: '/ai-bk360.png',
    text: 'Xây dựng học liệu số bằng AI (BK360 AI)',
    url: 'https://lms360.edu.vn/danh-sach-khoa-hoc'
  },
  {
    iconUrl: '/ai-chatbot.png',
    text: 'Trợ lý ảo Chat360 AI',
    url: 'https://lms360.edu.vn'
  }
];

export const teachingLinks = [
  {
    iconUrl: '/teaching-lms.png',
    text: 'Hệ thống Quản lý học tập trực tuyến LMS360 e-Learning',
    url: 'https://lms360.edu.vn/'
  },
  {
    iconUrl: '/teaching-lcms.png',
    text: 'Hệ thống quản lý và soạn giảng nội dung tương tác (LCMS)',
    url: 'https://lms360.edu.vn/tao-noi-dung-h5p'
  },
  {
    iconUrl: '/teaching-exams.png',
    text: 'Quản lý ngân hàng đề thi',
    url: 'https://lms360.edu.vn/danh-sach-khoa-hoc-bkt'
  },
  {
    iconUrl: '/teaching-test.png',
    text: 'Hệ thống kiểm tra đánh giá trực tuyến TEST360',
    url: 'https://thi.lms360.edu.vn/'
  },
  {
    iconUrl: '/teaching-sparta.png',
    text: 'Hệ thống khảo sát năng lực ngoại ngữ (nghe-nói-đọc-viết)',
    url: 'https://spartaedu.com/register?a=Bachkhoatechnology',
    partner: 'sparta'
  },
  {
    iconUrl: '/teaching-ielts.png',
    text: 'Thi thử IELTS',
    url: 'https://spartaedu.com/register?a=Bachkhoatechnology',
    partner: 'sparta'
  }
];

export const digitalRecoursesLinks = [
  {
    iconUrl: '/digital-public.png',
    text: 'Ngân hàng học liệu số chia sẻ dùng chung',
    url: 'https://lms360.edu.vn/danh-sach-khoa-hoc-bkt'
  },
  {
    iconUrl: '/digital-gdpt.png',
    text: 'Học liệu số bản quyền theo CT GDPT 2018',
    url: 'https://lms360.edu.vn/danh-sach-khoa-hoc-nxb'
  },
  {
    iconUrl: '/digital-summer.png',
    text: 'Học liệu số tập huấn chuyên môn hè',
    url: 'https://lms360.edu.vn/summer-training'
  },
  {
    iconUrl: '/digital-school.png',
    text: 'Ngân hàng học liệu số cấp trường',
    url: 'https://lms360.edu.vn/kho-hoc-lieu-cua-truong'
  },
  {
    iconUrl: '/digital-ai.png',
    text: 'Ngân hàng học liệu số xây dựng bằng AI',
    url: 'https://lms360.edu.vn/hoc-lieu-so-ai-mau'
  },
  {
    iconUrl: '/digital-virtual.png',
    text: 'Phòng thí nghiệm mô phỏng',
    url: 'https://lms360.edu.vn/phong-thi-nghiem-ao'
  }
];

export const otherServicesLinks = [
  {
    iconUrl: '/others-teaching.png',
    text: 'Đào tạo chuyển đổi phương pháp giảng dạy',
    url: 'https://lms360.edu.vn'
  },
  {
    iconUrl: '/others-teaching.png',
    text: 'Đào tạo ứng dụng AI trong dạy và học',
    url: 'https://lms360.edu.vn'
  },
  {
    iconUrl: '/others-teaching.png',
    text: 'Đào tạo tổ chức kiểm tra đánh giá trực tuyến',
    url: 'https://lms360.edu.vn'
  },
  {
    iconUrl: '/others-teaching.png',
    text: 'Đào tạo kỹ năng số, công dân số',
    url: 'https://lms360.edu.vn'
  },
  {
    iconUrl: '/others-teaching.png',
    text: 'Đào tạo thiết kế bài giảng e-Learning',
    url: 'https://lms360.edu.vn'
  },
  {
    iconUrl: '/others-teaching.png',
    text: 'Đào tạo về tiêu chuẩn, tiêu chí học liệu số e -Learning',
    url: 'https://lms360.edu.vn'
  },
  {
    iconUrl: '/others-teaching.png',
    text: 'Đào tạo tiêu chuẩn, xây dựng & vận hành trường học số',
    url: 'https://lms360.edu.vn'
  },
  {
    iconUrl: '/others-devices.png',
    text: 'Thiết bị số',
    url: 'https://lms360.edu.vn'
  },
  {
    iconUrl: '/others-school.png',
    text: 'Trường học thông minh',
    url: 'https://lms360.edu.vn'
  },
  {
    iconUrl: '/others-cloud.png',
    text: 'Dịch vụ lưu trữ đám mây (Cloud)',
    url: 'https://lms360.edu.vn'
  },
  {
    iconUrl: '/others-stem.png',
    text: 'STEM, STEAM, ROBOTIC',
    url: 'https://lms360.edu.vn'
  },
  {
    iconUrl: '/others-virus.png',
    text: 'Phần mềm diệt virus bản quyền',
    url: 'https://lms360.edu.vn'
  },
  {
    iconUrl: '/others-mantain.png',
    text: 'Dịch vụ bảo dưỡng, bảo trì thiết bị, cơ sở vật chất',
    url: 'https://lms360.edu.vn'
  }
];

export const managementLinks = [
  {
    iconUrl: '/manage-sms.png',
    text: 'Hệ thống quản lý trường học SMS360',
    url: 'https://qlth.lms360.edu.vn/'
  },
  {
    iconUrl: '/manage-time.png',
    text: 'Phần mềm sắp xếp thời khóa biểu',
    url: 'https://qlth.lms360.edu.vn/school-admin/lich-giang-day/thoi-khoa-bieu?'
  },
  {
    iconUrl: '/manage-slldt.png',
    text: 'Sổ liên lạc điện tử',
    url: 'https://qlth.lms360.edu.vn/school-admin/slldt/'
  },
  {
    iconUrl: '/manage-report.png',
    text: 'Báo cáo chuyên cần, xin phép, duyệt phép trực tuyến',
    url: 'https://qlth.lms360.edu.vn/school-admin/thong-ke/chuyen-can-hoc-sinh'
  },
  {
    iconUrl: '/manage-attendance.png',
    text: 'Điểm danh thông minh trên ứng dụng di động',
    url: 'https://qlth.lms360.edu.vn/school-admin/diem-danh-thong-minh/'
  },
  {
    iconUrl: '/manage-attendance-gv.png',
    text: 'Phần mềm điểm danh giáo viên',
    url: 'https://qlth.lms360.edu.vn/school-admin/diem-danh-thong-minh'
  },
  {
    iconUrl: '/manage-blockchain.png',
    text: 'Học bạ số với công nghệ Blockchain',
    url: 'https://qlth.lms360.edu.vn/school-admin/ho-so-luu-tru/hoc-ba-so'
  },
  {
    iconUrl: '/manage-marketing.png',
    text: 'Ứng dụng truyền thông nội bộ',
    url: 'https://qlth.lms360.edu.vn/school-admin/announcement/'
  },
  {
    iconUrl: '/manage-sign.png',
    text: 'Chữ ký số',
    url: 'https://qlth.lms360.edu.vn/school-admin/management/ky-dien-tu/'
  },
  {
    iconUrl: '/manage-medical.png',
    text: 'Y tế học đường',
    url: 'https://qlth.lms360.edu.vn/school-admin/y-te-hoc-duong/'
  },
  {
    iconUrl: '/manage-tdkt.png',
    text: 'Thi đua khen thưởng',
    url: 'https://thiduakhenthuong.hcm.edu.vn/'
  },
  {
    iconUrl: '/manage-danh-gia.png',
    text: 'Hệ thống đánh giá và tự đánh giá',
    url: 'https://thidua.vn/'
  },
  {
    iconUrl: '/manage-kiem-dinh.png',
    text: 'Phần mềm kiểm định chất lượng giáo dục',
    url: 'https://kiemdinh.lms360.edu.vn/'
  }
];

export const bachKhoaLinks = [
  { text: 'Giới thiệu', url: 'https://bachkhoa.tech/about' },
  { text: 'Tầm nhìn - Sứ mệnh', url: 'https://bachkhoa.tech/about' },
  { text: 'Khách hàng tiêu biểu', url: 'https://bachkhoa.tech/products' },
  { text: 'Tin tức', url: 'https://bachkhoa.tech/news' },
  { text: 'Tuyển dụng', url: 'https://bachkhoa.tech/news' },
  { text: 'Phân phối sản phẩm', url: 'https://lms360.edu.vn/?open_contact=1' },
  { text: 'Liên hệ hỗ trợ', url: 'https://lms360.edu.vn/?open_contact=1' },
  {
    text: 'Chính sách bảo mật',
    url: 'https://lms360.edu.vn/chinh-sach-bao-mat'
  },
  {
    text: 'Điều khoản sử dụng',
    url: 'https://lms360.edu.vn/dieu-khoan-su-dung'
  }
];
